import cn from "classnames";
import style from "./rounded-toggle.module.css";
import { useRef } from "react";
import { useHover } from "frontend/ui-components/floaters/use-hover";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";

export const RoundedToggle = ({
  name,
  label,
  checked,
  setChecked,
  defaultChecked,
  className,
  tooltip,
  design,
}: {
  name?: string;
  className?: string;
  label?: React.ReactNode;
  checked?: boolean;
  defaultChecked?: boolean;
  setChecked?: (checked: boolean) => void;
  tooltip?: string;
  design?: "default" | "monday";
}) => {
  const labelRef = useRef<HTMLLabelElement>(null);
  const labelHover = useHover(labelRef);

  return (
    <>
      <label className={cn(style.switch, design === "monday" ? style.cimSwitch : "")} ref={labelRef}>
        {label}
        <input
          name={name}
          type="checkbox"
          checked={checked}
          onChange={(e) => setChecked && setChecked(e.currentTarget.checked)}
          defaultChecked={defaultChecked}
        />
        <div className={cn(style.slider, style.round, className)}></div>
      </label>
      {tooltip && labelHover && (
        <Tooltip
          design="monday"
          label={tooltip}
          relativeTo={labelRef}
          side={"bottom"}
          customStyle={{ borderRadius: 3 }}
        />
      )}
    </>
  );
};
